import { Links, Meta, Scripts, ScrollRestoration, isRouteErrorResponse, useRouteError } from 'react-router';
import App from './App.jsx';
import { ErrorAlert } from './components/ui.jsx';
import { notFoundMeta } from './seo.js';
import './styles/app.css';

const ICON = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><rect width='32' height='32' rx='7' fill='%2300b8a0'/><text x='16' y='22' font-size='15' font-family='sans-serif' font-weight='700' text-anchor='middle' fill='white'>CVR</text></svg>";

// The theme is set before the first paint, so a dark page does not flash light.
// App.jsx keeps it in step after that.
const THEME_SCRIPT = "try{var t=localStorage.getItem('cvr.theme');if(t)document.documentElement.dataset.theme=t}catch(e){}";

export const links = () => [{ rel: 'icon', href: ICON }];

// Only a page with no meta of its own gets this, for example an unknown path.
export const meta = ({ error }) => (error ? notFoundMeta() : [{ title: 'CVR register' }]);

export function Layout({ children }) {
  return (
    <html lang="da" suppressHydrationWarning>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <script dangerouslySetInnerHTML={{ __html: THEME_SCRIPT }} />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default App;

export function ErrorBoundary() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error) && error.status === 404
    ? 'This page does not exist.'
    : error;
  return (
    <App>
      <ErrorAlert error={typeof message === 'string' ? { message } : message} />
    </App>
  );
}
